import mapSearchParamsToQueryObject from 'src/utils/mapSearchParamsToQueryObject';
import filtersShortNames from 'src/consts/filtersShortNames.json';

const flattenAndFilterSearchParameters = (searchParameters) => {
  const searchQuery = mapSearchParamsToQueryObject({
    ...searchParameters,
    radius: !searchParameters.radiusDisabled ? searchParameters.radius : '',
  });

  return Object.keys(searchQuery)
    .filter((criteriaName) => searchQuery[criteriaName] !== '')
    .filter(
      (criteriaName) =>
        !(
          Array.isArray(searchQuery[criteriaName]) &&
          searchQuery[criteriaName].length === 0
        )
    )
    .reduce(
      (parameters, criteriaName) => {
        if (Array.isArray(searchQuery[criteriaName])) {
          return {
            ...parameters,
            [criteriaName]: searchQuery[criteriaName].join(','),
          };
        }
        if (searchQuery[criteriaName] !== '') {
          return {
            ...parameters,
            [criteriaName]: String(searchQuery[criteriaName]),
          };
        }
        return parameters;
      },
      {
        [filtersShortNames.pageNumber]: '1',
        [filtersShortNames.rowOnPage]: '50',
      }
    );
};

const extractQuery = ({ tokens = [], value = '' }) => {
  const query = tokens.map((token) => token.text || token.label);
  return (value.replace(' ', '').length > 0 ? [...query, value] : query).join(
    ','
  );
};

const buildSearchParametersForAnalytics = (searchParameters = {}) => {
  const { keyword, workplace } = searchParameters.autocomplete;
  const allSearchCriteria = flattenAndFilterSearchParameters(
    searchParameters.current
  );

  const query = {
    [filtersShortNames.keyword]: extractQuery(keyword),
    [filtersShortNames.workplace]: extractQuery(workplace),
  };

  const searchCriteria = Object.fromEntries(
    Object.keys(allSearchCriteria)
      .filter(
        (criteriaName) =>
          ![filtersShortNames.pageNumber, filtersShortNames.rowOnPage].includes(
            criteriaName
          )
      )
      .map((parameterName) => [parameterName, allSearchCriteria[parameterName]])
  );

  return {
    query,
    searchCriteria,
  };
};

export default buildSearchParametersForAnalytics;
